module.exports = __webpack_public_path__ + "static/media/T25.c6e65067.png";